import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useLazyGetCartDetailsByIdQuery } from "../../../../redux/services/cartSearchService";
import { useSelector } from "react-redux";
import "./index.css";
import man from '../../../../assets/icons/man.PNG';
import { Input } from "reactstrap";

const CartPerson = () => {
  const selectedCartData = useSelector((state: any) => state?.cart?.selectedCart);
  const [triggerCartDetails, { data: cartData, isLoading: isFetching }] = useLazyGetCartDetailsByIdQuery();

  useEffect(() => {
    if (selectedCartData?.id) {
      triggerCartDetails(selectedCartData.id);
    }
    if (selectedCartData?.cartId) {
      triggerCartDetails(selectedCartData?.cartId);
    }
  }, [selectedCartData?.id, triggerCartDetails, selectedCartData?.cartId]);


  const renderStars = (rating: number) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
      <>
        {[...Array(fullStars)].map((_, index) => (
          <FontAwesomeIcon key={index} icon={faStar} className="text-warning" />
        ))}
        {halfStar && (
          <FontAwesomeIcon icon={faStarHalfAlt} className="text-warning" />
        )}
        {[...Array(emptyStars)].map((_, index) => (
          <FontAwesomeIcon key={index} icon={faStar} className="text-muted" />
        ))}
      </>
    );
  };
  return (
    <>
      {!cartData?.owner ? (
        <div
          className="d-flex justify-content-center align-items-center"
        >
          <h3 className="mt-5">
            {selectedCartData?.displayName || cartData.displayName} cart is not assigned to the cart person.
          </h3>
        </div>
      ) : (
        <>
          {isFetching ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" variant="primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <span className="ms-2">Please Wait ...</span>
            </div>
          ) : (
            <div className="cart-view-cart-person-details">
              <div className="cart-view-cart-person-details-with-photo">
                <img
                  src={selectedCartData?.owner?.photoUrl || selectedCartData?.owner?.photoUrl || man}
                  alt={selectedCartData?.owner?.displayName || cartData?.owner?.displayName}
                  className="cart-view-cart-person-photo"
                  onError={(e) => {
                    e.currentTarget.src = man;
                  }}
                />
              </div>
              <div className="cart-view-cart-person-details-without-photo row">
                <div className="col">
                  <div className="cart-view-cart-person-details-without-photo-name-btn">
                    <h5 className="cart-view-cart-person-details-name">
                      {cartData?.owner?.displayName || selectedCartData?.owner?.displayName}
                    </h5>
                  </div>
                  {renderStars(4.5)}
                </div>
                <div className="col p-1">
                  <div className="cart-view-cart-person-details-contact-details-columns">
                    <h6 className="cart-view-cart-person-details-contact-details-headers">
                      Identity Document
                    </h6>
                    <img
                      src={cartData?.owner?.identityDocumentUrl || selectedCartData?.owner?.identityDocumentUrl}
                      alt="identityDocument"
                      className="cart-view-cart-person-idendity-document"
                    />
                  </div>
                </div>
                <hr />

                <h5>Contact Details</h5>
                <br />
                <div className="cart-view-cart-person-details-contact-details px-5">
                  <div className="cart-view-cart-person-details-contact-details-email">
                    <h6 className="cart-view-cart-person-details-contact-details-headers">
                      Email Address
                    </h6>
                    {cartData?.owner?.email || selectedCartData?.owner?.email}
                  </div>
                  <div className="cart-view-cart-person-details-contact-details-phone-number">
                    <h6 className="cart-view-cart-person-details-contact-details-headers">
                      Phone Number
                    </h6>
                    {cartData?.owner?.phoneNumber || selectedCartData?.owner?.phoneNumber}
                  </div>
                </div>
                <Row>
                  <Col><h5>Business Information</h5></Col>
                </Row>
                <Row>
                  <Col lg="4"><h6>Merchant Id</h6></Col>
                  <Col lg="8"><Input value={cartData?.owner?.merchantId} disabled /></Col>
                </Row>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CartPerson;
